__webpack_require__.p = "/Take-away-bakery/";